import {
  InternalViewModel, StringPropertyViewModel, NumericPropertyViewModel, CollectionViewModelTypeDecorator,
  ExternalViewModelTypeDecorator,
  NNumericPropertyViewModel,
  NDateTimeOffsetPropertyViewModel
} from '@nts/std';
import { ExpenseData } from '../../domain-models/expense-data';
import { ReceiptParamsIdentity } from '../../domain-models/receipt-params.identity';
import { ExpenseFileCollectionViewModel } from '../../view-models/expense-file.collection-view-model';
import { ExpenseTypeExtViewModel } from '../../view-models/expense-type.ext-view-model';
import { CurrencyExtViewModel } from '../../view-models/currency.ext-view-model';
import { BigNumber } from '@nts/std/types';

export class GeneratedExpenseDataViewModel extends InternalViewModel<ExpenseData, ReceiptParamsIdentity> {

  private _id: NumericPropertyViewModel<number>;

  public get id(): NumericPropertyViewModel<number> {
    return this.getNumericPropertyViewModel<number>((value) => { this._id = value; }, this._id, 'id');
  }

  private _expenseDate: NDateTimeOffsetPropertyViewModel;

  public get expenseDate(): NDateTimeOffsetPropertyViewModel {
    return this.getNDateTimeOffsetPropertyViewModel((value) => { this._expenseDate = value; }, this._expenseDate, 'expenseDate');
  }

  private _expenseTypeCode: NNumericPropertyViewModel<number>;

  public get expenseTypeCode(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._expenseTypeCode = value; }, this._expenseTypeCode, 'expenseTypeCode');
  }

  @ExternalViewModelTypeDecorator(ExpenseTypeExtViewModel)
  public expenseTypeRef: ExpenseTypeExtViewModel;

  private _expenseTotalAmount: NumericPropertyViewModel<BigNumber>;

  public get expenseTotalAmount(): NumericPropertyViewModel<BigNumber> {
    return this.getNumericPropertyViewModel<BigNumber>((value) => { this._expenseTotalAmount = value; }, this._expenseTotalAmount, 'expenseTotalAmount');
  }

  private _exchangeRateQuote: NNumericPropertyViewModel<number>;

  public get exchangeRateQuote(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._exchangeRateQuote = value; }, this._exchangeRateQuote, 'exchangeRateQuote');
  }

  private _description: StringPropertyViewModel;

  public get description(): StringPropertyViewModel {
    return this.getStringPropertyViewModel((value) => { this._description = value; }, this._description, 'description');
  }

  private _note: StringPropertyViewModel;

  public get note(): StringPropertyViewModel {
    return this.getStringPropertyViewModel((value) => { this._note = value; }, this._note, 'note');
  }

  @CollectionViewModelTypeDecorator(ExpenseFileCollectionViewModel)
  public files: ExpenseFileCollectionViewModel;

  private _expenseTypeDescription: StringPropertyViewModel;

  public get expenseTypeDescription(): StringPropertyViewModel {
    return this.getStringPropertyViewModel((value) => { this._expenseTypeDescription = value; }, this._expenseTypeDescription, 'expenseTypeDescription');
  }

  private _leadId: NNumericPropertyViewModel<number>;

  public get leadId(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._leadId = value; }, this._leadId, 'leadId');
  }

  private _leadCompanyId: NNumericPropertyViewModel<number>;

  public get leadCompanyId(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._leadCompanyId = value; }, this._leadCompanyId, 'leadCompanyId');
  }

  private _customerId: NNumericPropertyViewModel<number>;

  public get customerId(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._customerId = value; }, this._customerId, 'customerId');
  }

  private _customerCompanyId: NNumericPropertyViewModel<number>;

  public get customerCompanyId(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._customerCompanyId = value; }, this._customerCompanyId, 'customerCompanyId');
  }

  private _commissionId: NNumericPropertyViewModel<number>;

  public get commissionId(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._commissionId = value; }, this._commissionId, 'commissionId');
  }

  private _commissionCompanyId: NNumericPropertyViewModel<number>;

  public get commissionCompanyId(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._commissionCompanyId = value; }, this._commissionCompanyId, 'commissionCompanyId');
  }

  private _currencyId: NNumericPropertyViewModel<number>;

  public get currencyId(): NNumericPropertyViewModel<number> {
    return this.getNNumericPropertyViewModel<number>((value) => { this._currencyId = value; }, this._currencyId, 'currencyId');
  }

  @ExternalViewModelTypeDecorator(CurrencyExtViewModel)
  public currencyRef: CurrencyExtViewModel;

}
